import { render, staticRenderFns } from "./categoryTree.vue?vue&type=template&id=409bb531&scoped=true"
import script from "./categoryTree.vue?vue&type=script&lang=ts"
export * from "./categoryTree.vue?vue&type=script&lang=ts"
import style0 from "./categoryTree.vue?vue&type=style&index=0&id=409bb531&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409bb531",
  null
  
)

export default component.exports